import styled from "@emotion/styled";
import { DSTestResultPage } from "@hundred5/design-system";
import { Trans, useLingui } from "@lingui/react/macro";
import { Illustration } from "./illustration";

export function LegacyLinkPage() {
  const { t } = useLingui();

  return (
    <GridContainer>
      <InnerContainer>
        <Illustration />
        <h1>
          <Trans>This link is no longer available</Trans>
        </h1>
        <CopyContainer>
          <div>
            <h2>
              <Trans>Search engine or jobs board</Trans>
            </h2>
            <p>
              <Trans>
                If you discovered this job via a search engine or jobs board,
                please contact the hiring company.
              </Trans>
            </p>
            <h2>
              <Trans>Invited by a recruiter</Trans>
            </h2>
            <p>
              <Trans>
                If you were invited to take this test by a recruiter or hiring
                manager, please contact them for a new link. They will be able
                to re-invite you to the test.
              </Trans>
            </p>
          </div>
        </CopyContainer>
      </InnerContainer>
      <Footer>
        <DSTestResultPage.PoweredBy
          label={t`Powered by`}
          linkUrl="https://togglhire.com"
          labelColor="purple-60"
          logoColor="purple-60"
          logoHeight="18px"
        />
      </Footer>
    </GridContainer>
  );
}

const GridContainer = styled.div`
  background: ${({ theme }) => theme.colors.purple[10]};
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: auto 1fr;
  height: 100vh;
`;

const InnerContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  grid-column-start: 2;
  grid-row-start: 2;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 48px;
  max-width: 553px;

  @media (min-width: 768px) {
    margin-top: 120px;
  }

  h1 {
    font-family: GT Haptik;
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 24px;
    margin-top: 24px;
    text-align: center;
  }

  h2,
  p {
    font-size: 14px;
    line-height: 21px;
    margin: 0;
  }

  p + h2 {
    margin-top: 24px;
  }
`;

const CopyContainer = styled.div`
  background: ${({ theme }) => theme.colors.purple[5]};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.purple[60]};
  padding: 12px;

  @media (min-width: 768px) {
    padding: 24px;
  }
`;

const Footer = styled.footer`
  align-items: end;
  display: flex;
  grid-column-end: 4;
  grid-column-start: 1;
  grid-row-start: 3;
  justify-content: end;
  padding: 24px;

  @media (min-width: 768px) {
    padding: 32px;
  }
`;
